<template>
  <OCol class="pa-2 maxh-1bar scroll-y" v-if="hasClient">

    <div class="d-flex items-center justify-center ma-4">
      <v-btn :href="`/tools/unpauser/index.html?clientId=${value.id}`" target="blank">Abrir no Unpauser V2
        <v-icon small class="ml-2">mdi-open-in-new</v-icon>
      </v-btn>
    </div>

    <ORow top wrap>
      <div class="col-md-2 col-12 pa-2">
        <Sidebar />
      </div>

      <div class="col-md-5 pa-2">
        <Queues />
      </div>

      <div class="col-md-5 pa-2">
        <Trips />
      </div>
    </ORow>
    <ORow stretch-x class="pa-2">

      <!-- <LastHb /> -->
    <!-- </ORow>
    <ORow stretch-x class="pa-2"> -->
      <HbsToResend />
    </ORow>
  </OCol>
</template>

<script>
import Trips from './Trips.vue'
import HbsToResend from './HbsToResend.vue'
import Queues from './Queues.vue'
import Sidebar from './Sidebar.vue'
import UnpauserStore from './UnpauserStore'

export default {
  components: {
    Sidebar,
    Queues,
    Trips,
    HbsToResend
  },

  tabTitle: 'Unpauser',
  tabGroup: 'Módulo',

  // chamado pelo TabContainer antes de montar este componente,
  // apenas para decorar a tab na sidebar lateral
  tabBadgeFn: (client) => {
    let text = ''
    if (client.isPaused) text += 'P'
    if (client.isIgnored) text += 'I'

    let color = null
    if (client.isIgnored) color = 'red'
    else if (client.isPaused) color = 'amber'

    if (text == '') return null
    else return { text, color }
  },
  props: {
    value: { required: true }
  },
  computed: {
    hasClient() {
      return UnpauserStore.client != null
    }
  },
  watch: {
    value() {
      UnpauserStore.setClientId(this.value.id)
    }
  },
  mounted() {
    UnpauserStore.setClientId(this.value.id)
  }
}
</script>

<style></style>
